var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getBuildedMatfileTemplate } from '@/helpers/matfile';
export default (function (options, data) {
    var _a, _b;
    var _c = getBuildedMatfileTemplate(), format_version = _c.format_version, revision = _c.revision;
    var package_format_version = 3; // previously the version is taken from the material file (material -> general -> format_version = 2)
    var package_resources_version = 1;
    var creator_app_id = options.creator_app_id;
    var creator_app_name = options.creator_app_name;
    var _d = __read(process.env.VERSION_CONTROL.split('.').map(function (item) { return +item; }), 3), major = _d[0], minor = _d[1], patch = _d[2];
    var creator_app_version = { major: major, minor: minor, patch: patch };
    var material = ((_a = data === null || data === void 0 ? void 0 : data.material) === null || _a === void 0 ? void 0 : _a.contents)
        ? [
            {
                file_name: 'material.json',
                format_version: format_version,
                data_revision: revision,
                encoding: 'base64',
            },
        ]
        : [];
    var material_metadata = ((_b = data === null || data === void 0 ? void 0 : data.project_metadata) === null || _b === void 0 ? void 0 : _b.material_metadata)
        ? [
            {
                file_name: 'material-metadata.json',
                format_version: format_version,
                data_revision: revision,
                encoding: 'base64',
            },
        ]
        : [];
    var project = (data === null || data === void 0 ? void 0 : data.project)
        ? [
            {
                file_name: 'project.json',
                format_version: 2,
                data_revision: 1,
                encoding: 'plaintext',
            },
        ]
        : [];
    var project_metadata = (data === null || data === void 0 ? void 0 : data.project_metadata)
        ? [
            {
                file_name: 'project-metadata.json',
                format_version: 1,
                data_revision: 1,
                encoding: 'plaintext',
            },
        ]
        : [];
    var wizard = (data === null || data === void 0 ? void 0 : data.wizard)
        ? [
            {
                file_name: 'wizard.json',
                format_version: 1,
                data_revision: 1,
                encoding: 'plaintext',
            },
        ]
        : [];
    var components = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(material), false), __read(material_metadata), false), __read(project), false), __read(project_metadata), false), __read(wizard), false);
    var payload = {
        package_format_version: package_format_version,
        package_resources_version: package_resources_version,
        creator_app_id: creator_app_id,
        creator_app_name: creator_app_name,
        creator_app_version: creator_app_version,
        components: components,
    };
    return payload;
});
